module.exports = __webpack_public_path__ + "static/media/credit-effect.5a284628.png";